import React, { FC, useMemo, useState } from 'react';
import TruncateMarkup from 'react-truncate-markup';
import parse from 'html-react-parser';
import { useTranslations } from 'next-intl';
import { pushGTMClickTags } from '@/libs/pushGTMTags/pushGTMTags';
interface TruncateReadmoreProps {
  text: string;
  classToken: string;
  numberOfLines: number;
  trimBy: string;
}
const TruncateReadmore: FC<TruncateReadmoreProps> = ({
  text,
  classToken,
  numberOfLines,
  trimBy
}) => {
  // Set toggle state for readmore
  const [toggleTruncate, setToggleTruncate] = useState(true);
  const t = useTranslations('Asset');

  // Memoize the parsed content to avoid unnecessary re-parsing
  const parsedContent = useMemo(() => parse(text), [text]);

  // Memoize the ellipsis component to avoid unnecessary re-renders
  const readMoreEllipsis = useMemo(() => <span>
    {' '}
    &hellip;{' '}
    <button className={'text-links-body-color bold'} onClick={() => {
      setToggleTruncate(false);
      pushGTMClickTags({
        click_element: 'button',
        click_closest_class: 'NONE',
        click_section_ID: '',
        link_classes: 'text-links-body-color bold',
        link_id: '',
        link_text: 'Show more',
        link_url: 'NONE',
        click_category: 'NONE',
        click_destination: 'NONE',
        click_closest_href: 'NONE'
      });
    }}>
     {t('ShowMore')}
    </button>
   </span>, [t]);

  // Force remount of TruncateMarkup when text changes to avoid stale props
  // (Note: setKey is referenced but not defined in your code. If you need this, define [key, setKey] = useState(0) and use key as a prop.)
  // useEffect(() => {
  //   setKey(prevKey => prevKey + 1);
  // }, [text, numberOfLines, trimBy]);

  // Check if the text var passed in is actually a string - required by truncation function
  // If not then we should bail early
  if (text?.length === 0 || typeof text != 'string') {
    return null;
  }
  if (toggleTruncate) {
    return <TruncateMarkup lines={numberOfLines} ellipsis={readMoreEllipsis} tokenize={trimBy}>
    <div className={classToken} data-bdd={classToken}>
     {parsedContent}
    </div>
   </TruncateMarkup>;
  } else {
    return <div className={classToken} data-bdd={classToken}>
    {parse(text)}
    <button className={'text-links-body-color bold'} onClick={() => {
        setToggleTruncate(prevToggle => !prevToggle);
        pushGTMClickTags({
          click_element: 'button',
          click_closest_class: classToken,
          click_section_ID: 'NONE',
          link_classes: 'text-links-body-color bold',
          link_id: 'NONE',
          link_text: 'Show less',
          link_url: 'NONE',
          click_category: 'NONE',
          click_destination: 'NONE',
          click_closest_href: 'NONE'
        });
      }}>
     &hellip;{' ' + t('ShowLess')}
    </button>
   </div>;
  }
};
export default TruncateReadmore;